"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKXUniversalProvider = void 0;
const eip155_1 = require("./provider/providers/eip155");
const sui_1 = require("./provider/providers/sui");
const constants_1 = require("./provider/constants");
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const client_1 = require("./packages/sign-client/client");
const core_1 = require("@okxconnect/core");
const namespaces_1 = require("./packages/utils/namespaces");
const solana_1 = __importDefault(require("./provider/providers/solana"));
const btc_1 = __importDefault(require("./provider/providers/btc"));
const aptos_1 = __importDefault(require("./provider/providers/aptos"));
const ton_1 = __importDefault(require("./provider/providers/ton"));
const cosmos_1 = __importDefault(require("./provider/providers/cosmos"));
const tron_1 = __importDefault(require("./provider/providers/tron"));
const utils_1 = require("./provider/utils");
const packages_1 = require("./packages");
const provider_1 = require("./provider");
class OKXUniversalProvider {
    static init(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, core_1.logDebug)('OKXUniversalProvider init() called');
            // ignore rpc provider check by default
            (0, utils_1.setGlobal)('disableProviderPing', true);
            let provider;
            if (window && window.okxConnectUniversalinwindow && window.okxConnectUniversalinwindow instanceof OKXUniversalProvider) {
                (0, core_1.logDebug)('OKXUniversalConnect init() old called');
                provider = window.okxConnectUniversalinwindow;
            }
            else {
                (0, core_1.logDebug)('OKXUniversalConnect init() new called');
                provider = new OKXUniversalProvider(opts);
                yield provider.initialize();
                if (window) {
                    window.okxConnectUniversalinwindow = provider;
                }
            }
            (0, core_1.getDefaultReporter)().configVersionAndSide('universalprovider-1.5.2', 'dapp', provider.providerOpts.dappMetaData.name);
            return provider;
        });
    }
    constructor(opts) {
        this.rpcProviders = {};
        this.events = new eventemitter3_1.default();
        this.providerOpts = opts;
    }
    request(args, chain) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, core_1.logDebug)('OKXUniversalProvider request() called');
            (0, core_1.reportLog)('OKXUniversalProvider request() called');
            if (!this.connected()) {
                throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.NOT_CONNECTED_ERROR);
            }
            const { namespace, requestParam } = this.buildRequestParamFromRequest(args, chain);
            return yield this.getProvider(namespace).request(requestParam);
        });
    }
    buildRequestParamFromRequest(args, chain) {
        var _a;
        (0, core_1.logDebug)("UniversalProvider request args >>>>>>>: ", chain, JSON.stringify(args));
        let [namespace, chainId] = this.validateChain(chain);
        if (!this.session) {
            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "Please call connect() before request()");
        }
        let keyArr = Object.keys(this.session.namespaces);
        if (!chain && keyArr && keyArr.length > 1) {
            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.NOT_CONNECTED_ERROR, `Multiple chains have been linked, the request method requires chain`);
        }
        if (namespace == "aptos" && chainId == "mainnet") {
            namespace = "aptos";
            chainId = "637";
        }
        if (namespace == "movement" && chainId == "testnet") {
            namespace = "aptos";
            chainId = "70000060";
        }
        const requestParam = Object.assign(Object.assign({}, args), { chainId: `${namespace}:${chainId}`, redirect: (_a = args.redirect) !== null && _a !== void 0 ? _a : this.sessionConfig.redirect });
        return { namespace, requestParam };
    }
    enable() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.client) {
                throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "Sign Client not initialized");
            }
            if (!this.session) {
                if (this.connectOpts) {
                    yield this.connect(this.connectOpts);
                }
                else {
                    throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "Sign Client not initialized");
                }
            }
            const accounts = yield this.requestAccounts();
            return accounts;
        });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, core_1.logDebug)('OKXUniversalProvider disconnect() called');
            (0, core_1.reportLog)('provider disconnect called');
            if (!this.session) {
                throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.NOT_CONNECTED_ERROR);
            }
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                let called = false;
                const onRequestSent = () => __awaiter(this, void 0, void 0, function* () {
                    if (!called) {
                        called = true;
                        yield this.disconnectAndEmit();
                        yield this.cleanup();
                        resolve();
                        (0, core_1.logDebug)("UniversalProvider disconnect Disconnected");
                        (0, core_1.reportLog)('provider disconnect disconnected');
                    }
                });
                try {
                    yield this.client.disconnect();
                    yield onRequestSent();
                }
                catch (e) {
                    yield onRequestSent();
                }
            }));
        });
    }
    disconnectAndEmit() {
        var _a, _b;
        this.client.engine.connectionManager.disconnect();
        this.events.emit("disconnect", { topic: (_a = this.session) === null || _a === void 0 ? void 0 : _a.topic });
        this.events.emit("session_delete", { topic: (_b = this.session) === null || _b === void 0 ? void 0 : _b.topic });
    }
    aptosChainNameToGeneralId(chainId) {
        if (chainId == "aptos:mainnet") {
            return "aptos:637";
        }
        else if (chainId == "movement:testnet") {
            return "aptos:70000060";
        }
        else {
            return chainId;
        }
    }
    replaceAptos(opts) {
        var _a, _b;
        let aptosNameSpace = (_a = opts.namespaces) === null || _a === void 0 ? void 0 : _a["aptos"];
        if (aptosNameSpace != undefined) {
            let realNS = this.replaceAptosInner(aptosNameSpace);
            if (opts.namespaces != undefined && "aptos" in opts.namespaces && realNS != undefined) {
                opts.namespaces.aptos = realNS;
            }
        }
        let optionAptosNameSpace = (_b = opts.optionalNamespaces) === null || _b === void 0 ? void 0 : _b["aptos"];
        if (optionAptosNameSpace != undefined) {
            let realOptionNS = this.replaceAptosInner(optionAptosNameSpace);
            if (opts.optionalNamespaces != undefined && "aptos" in opts.optionalNamespaces && realOptionNS != undefined) {
                opts.optionalNamespaces.aptos = realOptionNS;
            }
        }
        return opts;
    }
    replaceAptosInner(aptosNameSpace) {
        var _a;
        if (aptosNameSpace != undefined) {
            aptosNameSpace.chains = (_a = aptosNameSpace.chains) === null || _a === void 0 ? void 0 : _a.map(chainId => {
                return this.aptosChainNameToGeneralId(chainId);
            });
            if (aptosNameSpace.defaultChain != undefined) {
                aptosNameSpace.defaultChain = this.aptosChainNameToGeneralId(aptosNameSpace.defaultChain);
            }
        }
        return aptosNameSpace;
    }
    replaceAptosGeneralIdWithNetName(chainId) {
        if (chainId.includes("aptos:637")) {
            chainId = chainId.replace("aptos:637", "aptos:mainnet");
        }
        else if (chainId.includes("aptos:70000060")) {
            chainId = chainId.replace("aptos:70000060", "movement:testnet");
        }
        return chainId;
    }
    replaceSessionAptos(session) {
        var _a;
        let namespaces = (_a = session === null || session === void 0 ? void 0 : session.namespaces) === null || _a === void 0 ? void 0 : _a["aptos"];
        if (namespaces != undefined && namespaces.chains != undefined) {
            namespaces.chains = namespaces.chains.map(chain => {
                return this.replaceAptosGeneralIdWithNetName(chain);
            });
            namespaces.accounts = namespaces.accounts.map((account) => {
                return this.replaceAptosGeneralIdWithNetName(account);
            });
            let extra = {};
            Object.keys(namespaces.extra || {}).forEach((key, index) => {
                let newKey = this.replaceAptosGeneralIdWithNetName(key);
                extra[this.replaceAptosGeneralIdWithNetName(key)] = Object.values((session === null || session === void 0 ? void 0 : session.namespaces["aptos"].extra) || {})[index];
            });
            namespaces.extra = extra;
        }
        (0, core_1.logDebug)("replaceSessionAptos", session);
    }
    connected() {
        (0, core_1.logDebug)('OKXUniversalProvider connected() called');
        (0, core_1.reportLog)('provider connected called');
        let disconnectInner = () => {
            try {
                this.cleanup();
                this.client.engine.connectionManager.disconnect();
            }
            catch (e) {
                (0, core_1.logDebug)("Error during disconnect:", e);
            }
        };
        try {
            if (!this.session)
                return false;
            if (!this.client.engine.connectionManager.getCurrentConnectionReady()) {
                disconnectInner();
                return false;
            }
            return true;
        }
        catch (e) {
            disconnectInner();
            return false;
        }
    }
    connectAndSign(opts, signRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, core_1.logDebug)('OKXUniversalProvider connectAndSign() called');
            const updatedOpts = Object.assign(Object.assign({}, opts), { signRequest });
            (0, core_1.logDebug)('OKXUniversalProvider connectAndSign() opts:', JSON.stringify(opts));
            (0, core_1.logDebug)('OKXUniversalProvider connectAndSign() signRequest:', JSON.stringify(signRequest));
            return yield this.connect(updatedOpts);
        });
    }
    connect(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, core_1.logDebug)('OKXUniversalProvider connect() called');
            (0, core_1.reportLog)('provider connect called');
            if (!this.client) {
                throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "Sign Client not initialized");
            }
            if (this.connected()) {
                return this.session;
            }
            opts = this.replaceAptos(opts);
            (0, core_1.logDebug)(`OKXUniversalProvider connect >>>>`, JSON.stringify(opts));
            if (opts.sessionConfig === undefined) {
                opts.sessionConfig = {};
            }
            if (opts.sessionConfig.openUniversalUrl === undefined) {
                opts.sessionConfig.openUniversalUrl = (0, core_1.isMobileUserAgent)();
            }
            this.setNamespaces(opts);
            try {
                (0, core_1.logDebug)(`UniversalProvider connect opts.stringify ====> ${JSON.stringify(opts)}`);
                let session = yield this.client.connect(opts);
                this.replaceSessionAptos(session);
                (0, core_1.logDebug)(`UniversalProvider connect success ====> ${JSON.stringify(session)}`);
                if (session) {
                    this.session = session;
                    this.client.session = session;
                    (0, core_1.logDebug)(`OKXUniversalProvider connect success opts>>>>`, JSON.stringify(opts));
                    this.onConnect();
                    if (opts.signRequest && opts.signRequest.length > 0) {
                        let requestItem = opts.signRequest[0];
                        let signResponseList = [];
                        if (typeof window !== "undefined" && window && window.okxConnectUniversalUIinwindow) { //from UI
                            (0, core_1.logDebug)(`OKXUniversalProvider connect success, us UI SDK>>>>`);
                            if (this.session.signResponse && this.session.signResponse.length > 0) { // >=6.96
                                signResponseList = this.session.signResponse;
                            }
                        }
                        else {
                            (0, core_1.logDebug)(`OKXUniversalProvider connect success, us Universal SDK>>>>`);
                            if (this.session.signResponse && this.session.signResponse.length > 0) { // >=6.96
                                signResponseList = this.session.signResponse;
                            }
                            else {
                                signResponseList.push((0, packages_1.creatNotSupportMethodItemReplay)(requestItem));
                            }
                        }
                        (0, core_1.logDebug)(`UniversalProvider connect success connectRequestReply ====> ${JSON.stringify(signResponseList)}`);
                        setTimeout(() => {
                            this.events.emit("connect_signResponse", signResponseList);
                        }, 100);
                    }
                    return session;
                }
                return undefined;
            }
            catch (error) {
                (0, core_1.logDebug)(`UniversalProvider connect error ====> `, JSON.stringify(error));
                throw error;
            }
        });
    }
    syncAllAddresses() {
        return __awaiter(this, void 0, void 0, function* () {
            if ((0, provider_1.syncAddressAvailable)(this.session.wallet)) {
                return this.client.syncAllAddress();
            }
            else {
                throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
            }
        });
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    setDefaultChain(chain, rpcUrl) {
        (0, core_1.logDebug)('OKXUniversalProvider setDefaultChain() called');
        // chain = this.aptosChainNameToGeneralId(chain)
        try {
            // ignore without active session
            if (!this.connected())
                return;
            const [namespace, chainId] = this.validateChain(chain);
            const provider = this.getProvider(namespace);
            provider.setDefaultChain(chainId, rpcUrl);
        }
        catch (error) {
            // ignore the error if the fx is used prematurely before namespaces are set
            if (!/Please call connect/.test(error.message))
                throw error;
        }
    }
    checkStorage() {
        return __awaiter(this, void 0, void 0, function* () {
            let sessionInfoStr = yield this.getFromStore("connectSession");
            (0, core_1.logDebug)(sessionInfoStr);
            if (sessionInfoStr) {
                let sessionInfo = sessionInfoStr;
                this.session = sessionInfo;
                this.client.session = this.session;
                this.sessionConfig = sessionInfo.sessionConfig;
                this.client.sessionConfig = this.sessionConfig;
                (0, core_1.logDebug)('[evm u-provider] do reconnection', this.session);
                yield this.client.restoreconnect(sessionInfo);
                this.createProviders();
                this.registerEventListeners();
                setTimeout(() => {
                    this.events.emit("reconnect", { session: this.session });
                }, 100);
                this.registerEventListeners();
            }
        });
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, core_1.logDebug)('OKXUniversalProvider initialize() called');
            (0, core_1.reportLog)('provider initialize called');
            const data = Object.assign({ url: window.location.hostname, origin: window.location.origin }, this.providerOpts.dappMetaData);
            this.client = new client_1.SignClient(data, this.events);
            yield this.checkStorage();
        });
    }
    createProviders() {
        if (!this.client) {
            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "Sign Client not initialized");
        }
        if (!this.connected()) {
            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "Session not initialized. Please call connect() before enable()");
        }
        const providersToCreate = [
            ...new Set(Object.keys(this.session.namespaces).map((namespace) => (0, namespaces_1.parseNamespaceKey)(namespace))),
        ];
        providersToCreate.forEach((namespace) => {
            if (!this.session)
                return;
            const namespacesValue = this.session.namespaces;
            const currentNameSpace = namespacesValue[namespace];
            (0, core_1.logDebug)("init eip155 >> ", currentNameSpace);
            switch (namespace) {
                case "eip155":
                    const opts = {
                        namespace: currentNameSpace
                    };
                    this.rpcProviders[namespace] = new eip155_1.Eip155Provider(opts, this.client, this.events);
                    break;
                case "solana":
                    const opts1 = {
                        namespace: currentNameSpace
                    };
                    let solanaProvider = new solana_1.default(opts1, "solana", this.client, this.events);
                    this.rpcProviders[namespace] = solanaProvider;
                    let sonicProvider = new solana_1.default(opts1, "sonic", this.client, this.events);
                    this.rpcProviders['sonic'] = sonicProvider;
                    let svmProvider = new solana_1.default(opts1, "svm", this.client, this.events);
                    this.rpcProviders['svm'] = svmProvider;
                    // this.rpcProviders[namespace] = new SolanaProvider(opts1, () => { return this.session; });
                    break;
                case "ton":
                    const optsTon = {
                        namespace: currentNameSpace
                    };
                    let tonProvider = new ton_1.default(optsTon, this.client, this.events);
                    this.rpcProviders[namespace] = tonProvider;
                    break;
                case "sui":
                    const optsSui = {
                        namespace: currentNameSpace
                    };
                    let suiProvider = new sui_1.SuiProvider(optsSui, this.client, this.events);
                    suiProvider.name = "sui";
                    this.rpcProviders[namespace] = suiProvider;
                    break;
                case "btc":
                    const optsBtc = {
                        namespace: currentNameSpace
                    };
                    let btcProvider = new btc_1.default(optsBtc, "btc", this.client, this.events);
                    this.rpcProviders["btc"] = btcProvider;
                    let fbProvider = new btc_1.default(optsBtc, "fractal", this.client, this.events);
                    this.rpcProviders["fractal"] = fbProvider;
                    break;
                case "aptos":
                    let aptosProvider = new aptos_1.default({
                        namespace: currentNameSpace
                    }, "aptos", this.client, this.events);
                    this.rpcProviders[namespace] = aptosProvider;
                    let moveProvider = new aptos_1.default({
                        namespace: currentNameSpace
                    }, "movement", this.client, this.events);
                    this.rpcProviders["movement"] = moveProvider;
                    break;
                case "cosmos":
                    let cosmosProvider = new cosmos_1.default({
                        namespace: currentNameSpace
                    }, this.client, this.events);
                    this.rpcProviders[namespace] = cosmosProvider;
                    break;
                case "tron":
                    let tronProvider = new tron_1.default({
                        namespace: currentNameSpace
                    }, this.client, this.events);
                    this.rpcProviders[namespace] = tronProvider;
                    break;
            }
        });
    }
    registerEventListeners() {
        if (typeof this.client === "undefined") {
            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "Sign Client is not initialized");
        }
        this.client.engine.addDisconnectListener(() => {
            this.disconnectAndEmit();
            this.cleanup();
        });
        this.on(constants_1.PROVIDER_EVENTS.DEFAULT_CHAIN_CHANGED, (caip2ChainId) => {
            this.onChainChanged(caip2ChainId);
        });
        this.on(constants_1.PROVIDER_EVENTS.UPDATE_NAMESPACES, (nameSpaces) => {
            if (nameSpaces) {
                const nameSpacekey = Object.keys(nameSpaces)[0];
                if (this.session) {
                    this.session.namespaces[nameSpacekey] = nameSpaces[nameSpacekey];
                    if (this.session) {
                        this.persist("connectSession", this.session);
                        this.events.emit("session_update", this.session);
                    }
                    (0, core_1.logDebug)("PROVIDER_EVENTS.UPDATE_NAMESPACES this.session... ->>>", JSON.stringify(this.session));
                }
            }
        });
    }
    getProvider(namespace) {
        (0, core_1.logDebug)('current get providers', this.rpcProviders);
        (0, core_1.logDebug)('query namespace: ', namespace);
        return this.rpcProviders[namespace];
    }
    setNamespaces(params) {
        this.connectOpts = params;
        const { namespaces, sessionConfig } = params;
        const data = {
            origin: window.location.origin,
            url: window.location.hostname,
            name: this.providerOpts.dappMetaData.name,
            icon: this.providerOpts.dappMetaData.icon,
        };
        this.sessionConfig = Object.assign({ dappInfo: data }, sessionConfig);
        (0, core_1.logDebug)("setNamespaces sessionConfig>>>", this.sessionConfig);
        this.client.sessionConfig = this.sessionConfig;
        this.persist("sessionConfig", sessionConfig);
    }
    validateChain(chain) {
        var _a;
        let [namespace, chainId] = (chain === null || chain === void 0 ? void 0 : chain.split(":")) || ["", ""];
        if (!this.session || !this.session.namespaces || !Object.keys(this.session.namespaces).length) {
            (0, core_1.logDebug)('get name & chain', namespace, chainId);
            return [namespace, chainId];
        }
        if (namespace) {
            if (!this.isChainNamespaceInSession(namespace)) {
                throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.NOT_CONNECTED_ERROR, `Namespace '${namespace}' is not configured. Please call connect() first with namespace config.`);
            }
            if (chainId && chain) {
                (0, core_1.logDebug)('this.session.namespaces -->> ', namespace, JSON.stringify(this.session.namespaces));
                const chainsArr = (_a = this.session.namespaces[namespace]) === null || _a === void 0 ? void 0 : _a.chains;
                (0, core_1.logDebug)('get chainsArr & chain', JSON.stringify(chainsArr), chain);
                if (chainsArr && !chainsArr.includes(chain)) {
                    throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.NOT_CONNECTED_ERROR, `Namespace not include the chain '${chain}'`);
                }
            }
        }
        if (namespace && chainId) {
            (0, core_1.logDebug)('get name & chain', namespace, chainId);
            return [namespace, chainId];
        }
        let defaultNamespace = (0, namespaces_1.parseNamespaceKey)(Object.keys(this.session.namespaces)[0]);
        const defaultChain = this.rpcProviders[defaultNamespace].getDefaultChain();
        (0, core_1.logDebug)('get default chain:', defaultChain);
        return [defaultNamespace, defaultChain];
    }
    isChainNamespaceInSession(namespaceStr) {
        var _a, _b;
        if (Object.keys(((_a = this.session) === null || _a === void 0 ? void 0 : _a.namespaces) || {})
            .map((key) => (0, namespaces_1.parseNamespaceKey)(key))
            .includes(namespaceStr)) {
            return true;
        }
        let isChainNamespaceInSession = false;
        Object.values(((_b = this.session) === null || _b === void 0 ? void 0 : _b.namespaces) || {})
            .forEach(namespace => {
            namespace.chains.forEach(chain => {
                if (chain.split(":")[0] == namespaceStr) {
                    isChainNamespaceInSession = true;
                }
            });
        });
        return isChainNamespaceInSession;
    }
    requestAccountsWithNamespace(namespace) {
        return this.getProvider(namespace).requestAccounts();
    }
    requestDefaultChainWithNamespace(namespace) {
        return this.getProvider(namespace).getDefaultChain();
    }
    requestAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            const [namespace] = this.validateChain();
            return yield this.getProvider(namespace).requestAccounts();
        });
    }
    onChainChanged(caip2Chain) {
        var _a;
        if (!((_a = this.session) === null || _a === void 0 ? void 0 : _a.namespaces))
            return;
        const [namespace, chainId] = this.validateChain(caip2Chain);
        if (!chainId)
            return;
        if (this.session.namespaces[namespace]) {
            this.session.namespaces[namespace].defaultChain = chainId;
            this.persist("connectSession", this.session);
        }
        this.events.emit("chainChanged", chainId);
    }
    onConnect() {
        this.createProviders();
        if (this.session) {
            this.persist("connectSession", this.session);
        }
        this.events.emit("connect", { session: this.session });
        this.registerEventListeners();
    }
    cleanup() {
        return __awaiter(this, void 0, void 0, function* () {
            this.session = undefined;
            this.client.session = undefined;
            this.sessionProperties = undefined;
            this.persist("optionalNamespaces", undefined);
            this.persist("sessionProperties", undefined);
            this.persist("connectSession", undefined);
        });
    }
    persist(key, data) {
        (0, core_1.logDebug)('[evm u-provider] persisit data', key, data);
        return this.client.engine.connectionManager.saveSessionContent(key, data);
    }
    getFromStore(key) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.engine.connectionManager.getSessionContent(key);
        });
    }
    showRequestModal(args, chain) {
        try {
            const { namespace, requestParam } = this.buildRequestParamFromRequest(args, chain);
            return this.getProvider(namespace).showRequestModal(requestParam);
        }
        catch (e) {
            return false;
        }
    }
}
exports.OKXUniversalProvider = OKXUniversalProvider;
exports.default = OKXUniversalProvider;
